// src/components/WebsiteShowcase.jsx
import React, { useRef } from "react";
import styled from "styled-components";
import { motion, useScroll, useTransform } from "framer-motion";
import site1 from "../../assets/websites/w1.png";
import site2 from "../../assets/websites/web2.png";
import site3 from "../../assets/websites/w3.png";
import site4 from "../../assets/websites/w4.png";
import site5 from "../../assets/websites/web5.jpg";
import site6 from "../../assets/websites/w6.png";
import site7 from "../../assets/websites/w7.png";
import site8 from "../../assets/websites/w8.png";
import site9 from "../../assets/websites/w9.png";

const Section = styled.section`
  width: 100%;
  position: relative;
  height: 200vh; // enough scroll space
  /* background: #f8f8f8; */
`;

const StickyContainer = styled.div`
  position: sticky;
  top: 0;
  margin-top: 17em;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const GridWrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  width: 33.33%; // <-- start so center image fills full width
  max-width: 1200px;
`;

const GridItem = styled.div`
  aspect-ratio: 16/9;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
`;

export default function WebsiteShowcase() {
  const sectionRef = useRef(null);

  const images = [
    site1,
    site2,
    site3,
    site4,
    site5,
    site6,
    site7,
    site8,
    site9,
  ];

  // Scroll progress within section
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end end"],
  });

  // Container scale (zoomed in initially)
  const gridScale = useTransform(scrollYProgress, [0, 0.8], [10, 2.5]); // start zoomed in 3x -> normal
  const gridY = useTransform(scrollYProgress, [0, 0.5], ["0%", "0%"]);

  return (
    <Section ref={sectionRef}>
      <StickyContainer>
        <GridWrapper style={{ scale: gridScale, y: gridY }}>
          {images.map((img, idx) => (
            <GridItem key={idx} style={{ backgroundImage: `url(${img})` }} />
          ))}
        </GridWrapper>
      </StickyContainer>
    </Section>
  );
}
